import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, CardMedia, Input, Select, MenuItem, SelectChangeEvent } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddBouteekPoints({
    open,
    onClose,
    setOpen,
}: ModalProps) {


    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Bouteek Points</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" action="">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="reject-reason">Min Amount</label>
                                <TextField
                                    id="reject-reason"
                                    placeholder="Enter "
                                    fullWidth
                                    hiddenLabel

                                />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="reject-reason">Max Amount</label>
                                <TextField
                                    id="reject-reason"
                                    placeholder="Enter "
                                    fullWidth
                                    hiddenLabel

                                />
                            </div>
                            <div className="control_group">
                                <label htmlFor="reject-reason"> Points</label>
                                <TextField
                                    id="reject-reason"
                                    placeholder="Enter points"
                                    fullWidth
                                    hiddenLabel

                                />
                            </div>

                        </div>
                        <div className="footer_btn_flex">

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
